import React, { useEffect, useState } from 'react';
import { Container, Col, Image, Row } from 'react-bootstrap';
// import logoImage from "../assets/img/logoShirood.png"
// import logoImage from "../assets/img/logoAmol.png"
import Picture from "../assets/img/Picture11.png"
import final from "../assets/img/final.png"
import { NavLink } from 'react-router-dom'
import { apiUrl } from "../commons/inFormTypes";


function HeaderLogin({ logo, title }) {


  return <div>
    <header>
      <Container fluid className="rgc-header g-0">
        <Row className='justify-content-center g-0' >

          <Col xs={3} className="">
            <div className="rgc-logo mx-2">
              <Image src={logo} className="ms-auto" />
            </div>
          </Col>

          <Col xs={6} className="text-center">
            <div className="rgc-logo">
              <span>سامانه ارتباط مردمی</span>
              <span>{title}</span>
            </div>
          </Col>

          <Col xs={3} className="text-start">
            <div className="rgc-header-parent">
             <Image src={final} />
            </div>
          </Col>

        </Row>
      </Container>
    </header>
  </div>;
}

export default HeaderLogin;
